import { ReactComponent as BinIconSVG } from '../../../assets/images/icons/TrashCan.svg';

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

const BinIcon = (props: any) => {
	return (
		<SvgIcon {...props}>
			<BinIconSVG />
		</SvgIcon>
	);
};

export default BinIcon;